<template>
	<div>
		<h1>Partage d'éléments - récupération</h1>

        <div v-for="(l, key) in list" :key="key">
            <h2>{{names[key] || key}}</h2>

            <b-table striped hover :items="l" :fields="key == 'project' ? fields_uid : fields">
                <template v-slot:cell(share)="data">
                    <b-checkbox @change="setShare(data.index, data.item.share, key)" v-model="data.item.share"></b-checkbox>
                </template>
                <template v-slot:cell(automatic)="data">
                    <b-checkbox v-model="data.item.automatic" disabled></b-checkbox>
                </template>
            </b-table>
        </div>
	</div>
</template>

<script>
	import store from "../store";
	import shares from "../services/shares.js"

	export default {
        name: "share_get",
		components: {
		},
		data: function () {
			return {
                names: {
                    project: "Projets",
                    list: "Listes"
                },
                list: [],
                fields_uid: [{
                    key: "uid",
                    label: "Uid",
                    sortable: true
                },{
                    key: "libelle",
                    label: "Nom",
                    sortable: true
                },{
                    key: "share",
                    label: "Partage",
                    sortable: true
                }/*,{
                    key: "automatic",
                    label: "Partage automatique",
                    sortable: true
                }*/],
                fields: [{
                    key: "libelle",
                    label: "Nom",
                    sortable: true
                },{
                    key: "share",
                    label: "Partage",
                    sortable: true
                },{
                    key: "automatic",
                    label: "Automatiquement partagé",
                    sortable: true
                }]
			};
		},
		methods: {
			setShare(index, share, type)
            {
                this.$set(this.list[type], index, this.list[type][index]);

                if (share)
                {
					console.log(this.list[type][index])
                    shares.post("get", type, this.list[type][index].element_uid, {
                        client_uid: this.list[type][index].details.client_uid,
                        client_name: this.list[type][index].details.client_name,
                        name: this.list[type][index].libelle
                    });
                }
                else
                {
                    shares.delete("get", this.list[type][index].element_uid);
                }
            },
            get: async function () {
				var list = await shares.list_share();

				var list_get = await shares.list("get");
				
				var list_get_obj = {};
                var list_get_obj_auto = {};
                for (var i = 0; i < list_get.length; i++)
                {
                    if (list_get[i].client_uid)
                        list_get_obj[list_get[i].element_uid] = list_get[i];
                    else
                        list_get_obj_auto[list_get[i].element_uid] = list_get[i];
                }

                var list_obj = {};
				for (var i = 0; i < list.length; i++)
				{
                    if (!list_obj[list[i].element_type])
                        list_obj[list[i].element_type] = [];
					list_obj[list[i].element_type].push({
                        uid: list[i].element_uid,
                        element_uid: list[i].element_uid,
                        libelle: list[i].details.name,
                        details: list[i].details,
                        share: list_get_obj[list[i].element_uid] ? true : false,
                        automatic: list_get_obj_auto[list[i].element_uid] ? true : false
                    });
				}

				this.list = list_obj;
			}
		},
		mounted: async function () {
			var self = this;

			if (store.state.user.rules && !store.state.user.rules.share_get) {
				this.$router.push({ name: "profile" });
			}
			
			await this.get();
		},
	};
</script>

<style></style>
